import { ref, uploadString, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from './config';

/**
 * Base64 image'i Firebase Storage'a yükle ve public URL al
 * @param {string} base64Image - Base64 encoded image (data:image/jpeg;base64,...)
 * @param {string} userId - Kullanıcı ID
 * @param {string} fileName - Dosya adı
 */
export const uploadImageToStorage = async (base64Image, userId, fileName = null) => {
  try {
    // Dosya adı yoksa random oluştur
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(7);
    const finalFileName = fileName || `post_${timestamp}_${randomString}.jpg`;

    // Storage reference oluştur
    const storageRef = ref(storage, `posts/${userId}/${finalFileName}`);

    // Base64 string'i upload et
    const snapshot = await uploadString(storageRef, base64Image, 'data_url');

    // Public download URL al
    const downloadURL = await getDownloadURL(snapshot.ref);

    console.log('✅ Image uploaded to Firebase Storage:', downloadURL);

    return {
      success: true,
      url: downloadURL,
      path: snapshot.ref.fullPath
    };
  } catch (error) {
    console.error('❌ Image upload error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Video'yu Firebase Storage'a yükle
 * @param {string} base64Video - Base64 encoded video
 * @param {string} userId - Kullanıcı ID
 * @param {string} fileName - Dosya adı
 */
export const uploadVideoToStorage = async (base64Video, userId, fileName = null) => {
  try {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(7);
    const finalFileName = fileName || `video_${timestamp}_${randomString}.mp4`;

    // Storage reference oluştur
    const storageRef = ref(storage, `videos/${userId}/${finalFileName}`);

    // Base64 string'i upload et
    const snapshot = await uploadString(storageRef, base64Video, 'data_url');

    // Public download URL al
    const downloadURL = await getDownloadURL(snapshot.ref);

    console.log('✅ Video uploaded to Firebase Storage:', downloadURL);

    return {
      success: true,
      url: downloadURL,
      path: snapshot.ref.fullPath,
      type: 'video'
    };
  } catch (error) {
    console.error('❌ Video upload error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Birden fazla image'i yükle
 * @param {Array} images - Base64 image array
 * @param {string} userId - Kullanıcı ID
 */
export const uploadMultipleImages = async (images, userId) => {
  const results = [];

  for (let i = 0; i < images.length; i++) {
    const image = images[i];
    const result = await uploadImageToStorage(image.url, userId, `image_${i}_${Date.now()}.jpg`);
    results.push(result);
  }

  return results;
};

/**
 * Birden fazla medya (image + video) yükle
 * @param {Array} mediaItems - Base64 media array (type: 'image' veya 'video')
 * @param {string} userId - Kullanıcı ID
 */
export const uploadMultipleMedia = async (mediaItems, userId) => {
  const results = [];

  for (let i = 0; i < mediaItems.length; i++) {
    const item = mediaItems[i];

    if (item.type === 'video') {
      const result = await uploadVideoToStorage(item.url, userId, `video_${i}_${Date.now()}.mp4`);
      results.push(result);
    } else {
      const result = await uploadImageToStorage(item.url, userId, `image_${i}_${Date.now()}.jpg`);
      results.push(result);
    }
  }

  return results;
};

/**
 * Storage'dan dosya sil
 * @param {string} filePath - Silinecek dosyanın path'i
 */
export const deleteImageFromStorage = async (filePath) => {
  try {
    const fileRef = ref(storage, filePath);
    await deleteObject(fileRef);
    console.log('✅ Image deleted from Storage:', filePath);
    return { success: true };
  } catch (error) {
    console.error('❌ Image deletion error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Birden fazla image'i Storage'dan sil
 * @param {Array} filePaths - Silinecek dosyaların path'leri
 */
export const deleteMultipleImages = async (filePaths) => {
  const results = [];

  for (const filePath of filePaths) {
    const result = await deleteImageFromStorage(filePath);
    results.push(result);
  }

  return results;
};
